import classnames from 'classnames'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { getOpacityColor } from 'embed/utils'
import { css } from 'emotion'
import * as React from 'react'
import {
  LifeInsuranceADBLabel,
  LifeInsuranceMedicalExamLabels,
  LifeInsuranceOffer,
  LifeInsuranceProductSubType,
} from 'ui/multi-product/constants/models'

const Stethoscope = require('assets/components/stethoscope.svg')
const Globe = require('assets/components/globe.svg')
const Shield = require('assets/components/shield.svg')

const styles = require('./styles')

interface OfferFeatureBadgesContentProps {
  columnView?: boolean
  offer: LifeInsuranceOffer
  colorSecondary: string
  badgeStyle: {
    backgroundColor: string
    borderColor: string
    color: string
  }
}

export const OfferFeatureBadgeContents = (props: OfferFeatureBadgesContentProps) => {
  const { offer, columnView, colorSecondary, badgeStyle } = props
  const showAdbBadge = offer.productSubType === LifeInsuranceProductSubType.AccidentalDeathBenefits
  const hideMedicalBadge = offer.details.onlineAppAvailable && showAdbBadge

  return (
    <div className={classnames(styles.badgeWrapper, columnView && styles.columnView)}>
      {showAdbBadge && (
        <div
          className={classnames(
            styles.badgeItem,
            'adb-badge',
            css`
                  svg path {
                    fill: ${colorSecondary};
                `,
          )}
          style={badgeStyle}
        >
          <Shield />
          <p className={classnames([styles.badgeLabel, 'adb-badge-label'])}>{LifeInsuranceADBLabel}</p>
        </div>
      )}

      {!hideMedicalBadge && (
        <div
          className={classnames(
            styles.badgeItem,
            'medical-badge',
            css`
                  svg path {
                    fill: ${colorSecondary};
                `,
          )}
          style={badgeStyle}
        >
          <Stethoscope />
          <p className={classnames([styles.badgeLabel, 'medical-badge-label'])}>
            {LifeInsuranceMedicalExamLabels[offer.details.medicalExam]}
          </p>
        </div>
      )}

      {offer.details.onlineAppAvailable && (
        <div
          className={classnames(
            styles.badgeItem,
            css`
                  svg path {
                    stroke: ${colorSecondary};
                `,
          )}
          style={badgeStyle}
        >
          <Globe />
          <p className={styles.badgeLabel}>Easy Online Application</p>
        </div>
      )}
    </div>
  )
}

interface OfferFeatureBadgesProps {
  className?: string
  columnView?: boolean
  offer: LifeInsuranceOffer
}
export const OfferFeatureBadges = ({ offer, columnView }: OfferFeatureBadgesProps) => (
  <ThemeConsumer>
    {({ colorSecondary }) => {
      const badgeStyle = {
        backgroundColor: getOpacityColor(colorSecondary, 5),
        borderColor: colorSecondary,
        color: colorSecondary,
      }

      return (
        <OfferFeatureBadgeContents
          offer={offer}
          columnView={columnView}
          colorSecondary={colorSecondary}
          badgeStyle={badgeStyle}
        />
      )
    }}
  </ThemeConsumer>
)
